import React, { useState, useEffect } from 'react';
import userImage from '../../assets/images/userImage.png';
import useAuth from '../../providers/authProvider';
import FetchData, { AsyncCreateEntry } from '../../providers/dataProvider';
import { isValidPassword } from '../../utils/Validate';
import SaveSuccessModel from '../../components/common/SaveSuccessModel';

const Profile = () => {
    const [changePassword, setChangePassword] = useState(false);
    const [createMsg, setCreateMsg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [successShow, setSuccessShow] = useState(false);

    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: ''
    });

    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [errors, setErrors] = useState({});

    const { logout } = useAuth();
    const userName = localStorage.getItem("username");
    const IdentityId = localStorage.getItem("authidentity");
    const { data: userprofile } = FetchData("userprofile");

    const [userProfile, setUserProfile] = useState([]);
    useEffect(() => {
        const fetchUserProfile = async () => { };
        fetchUserProfile();
    }, [IdentityId, userProfile]);

    const { firstName, lastName, phone } = userProfile[0] || {};

    const handleLogout = () => { logout(); };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPasswordData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    };

    const handleCancelPassword = () => {
        setChangePassword(false);
        setPasswordData({ currentPassword: '', newPassword: '', confirmNewPassword: '' });
        setErrors({});
        setCreateMsg(null);
        setShowCurrentPassword(false);
        setShowNewPassword(false);
        setShowConfirmPassword(false);
    };

    const validateForm = () => {
        const validationErrors = {};

        const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\|,.<>\/?`~]{8,}$/;

        if (!passwordData.currentPassword.trim()) {
            validationErrors.currentPassword = 'Current Password is required';
        }

        if (!passwordData.newPassword.trim()) {
            validationErrors.newPassword = 'New Password is required';
        } else if (!strongPasswordRegex.test(passwordData.newPassword)) {
            validationErrors.newPassword = 'Password must be at least 8 characters and include uppercase, lowercase, number, and special character (e.g. Adm!N@Jmf5)';
        } else if (passwordData.newPassword === passwordData.currentPassword) {
            validationErrors.newPassword = 'New Password must be different from Current Password';
        }
        if (!passwordData.confirmNewPassword.trim()) {
            validationErrors.confirmNewPassword = 'Confirm Password is required';
        } else if (passwordData.newPassword !== passwordData.confirmNewPassword) {
            validationErrors.confirmNewPassword = 'New Password and Confirm Password do not match';
        }

        return validationErrors;
    };

    const handleSavePassword = async () => {
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);
        const result = await AsyncCreateEntry(
            "changepassword",
            {
                currentPassword: passwordData.currentPassword,
                newPassword: passwordData.newPassword,
                confirmNewPassword: passwordData.confirmNewPassword
            },
            "Password changed successfully!",
            "Failed to change password. Please try again."
        );
        setLoading(false);
        setCreateMsg(result);
    };

    useEffect(() => {
        if (!createMsg) return;

        if (createMsg?.status === 200) {
            setPasswordData({ currentPassword: '', newPassword: '', confirmNewPassword: '' });
            setErrors({});
            setChangePassword(false);

            const modalEl = document.getElementById('profileRightSideModalPopup');
            if (modalEl) {
                if (window.$ && window.$('#profileRightSideModalPopup').modal) {
                    window.$('#profileRightSideModalPopup').modal('hide');
                } else {
                    modalEl.classList.remove('show');
                    modalEl.style.display = 'none';
                    document.body.classList.remove('modal-open');
                    const backdrop = document.querySelector('.modal-backdrop');
                    if (backdrop) backdrop.remove();
                }
            }

            setSuccessShow(true);
        } else {

            const apiErrors = createMsg?.successData?.errors;
            const errMsg = (Array.isArray(apiErrors) && apiErrors.length > 0)
                ? apiErrors[0]?.message
                : createMsg?.successData?.message
                || createMsg?.successData?.title
                || createMsg?.message
                || 'Something went wrong. Please try again.';
            setErrors({ currentPassword: errMsg });
        }
    }, [createMsg]);

    const SuccessDoneClick = () => {
        setSuccessShow(false);
        setCreateMsg(null);
        logout();
    };

    useEffect(() => {
        if (successShow) {
            const timer = setTimeout(() => {
                logout();
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [successShow]);

    return (
        <>
            <div
                className="modal fade drawer right-align"
                id="profileRightSideModalPopup"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="profileRightSideModalPopupLabel"
            >
                <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                        <div className="header">
                            <div className='d-flex justify-content-between'>
                                <h5>Profile</h5>
                                <i className="fas fa-times" data-dismiss="modal"></i>
                            </div>
                            <div className='profile-img-area'>
                                <img src={userImage} className="user-img" alt="User" />
                            </div>
                            <div>
                                <form id="file-upload-form" className="uploader">
                                    <input id="file-upload-attachment" type="file" name="fileUpload" accept=".pdf" />
                                    <label htmlFor="file-upload-attachment" id="file-drag">
                                        <div id="start">
                                            <i className="fas fa-camera"></i>
                                        </div>
                                    </label>
                                </form>
                            </div>
                        </div>

                        <div className="modal-body">
                            <div className="row mt-3">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className='user-details-area'>
                                        <div>
                                            <h5 className='mt-3'>{userName}</h5>
                                            {firstName && lastName && phone && (
                                                <div>
                                                    <h5>{phone}</h5>
                                                    <h5>{firstName} {lastName}</h5>
                                                </div>
                                            )}
                                        </div>
                                        <hr />
                                        <div className='d-flex mt-3 justify-content-center'>
                                            <button
                                                type="button"
                                                className="btn change-password-btn"
                                                onClick={() => { setChangePassword(true); setErrors({}); }}
                                            >
                                                Change Password
                                            </button>
                                            <button
                                                type="button"
                                                className="btn log-out-btn"
                                                data-dismiss="modal"
                                                onClick={handleLogout}
                                            >
                                                Log Out
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {changePassword && (
                                <div className="row password-change-row mt-4">
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">

                                        {/* Current Password */}
                                        <div className='mb-2'>
                                            <label>Current Password</label>
                                            <div className="input-group">
                                                <input
                                                    type={showCurrentPassword ? 'text' : 'password'}
                                                    name="currentPassword"
                                                    className='form-control'
                                                    placeholder='Current Password'
                                                    value={passwordData.currentPassword}
                                                    onChange={handleInputChange}
                                                />
                                                <div className="input-group-append">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                                        tabIndex="-1"
                                                    >
                                                        <i className={`fas ${showCurrentPassword ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.currentPassword && (
                                                <div style={{ color: 'red' }}>{errors.currentPassword}</div>
                                            )}
                                        </div>

                                        {/* New Password */}
                                        <div className='mb-2'>
                                            <label>New Password</label>
                                            <div className="input-group">
                                                <input
                                                    type={showNewPassword ? 'text' : 'password'}
                                                    name="newPassword"
                                                    className='form-control'
                                                    placeholder='New Password'
                                                    value={passwordData.newPassword}
                                                    onChange={handleInputChange}
                                                />
                                                <div className="input-group-append">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                                        tabIndex="-1"
                                                    >
                                                        <i className={`fas ${showNewPassword ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.newPassword && (
                                                <div style={{ color: 'red' }}>{errors.newPassword}</div>
                                            )}
                                        </div>

                                        {/* Confirm Password */}
                                        <div className='mb-2'>
                                            <label>Confirm Password</label>
                                            <div className="input-group">
                                                <input
                                                    type={showConfirmPassword ? 'text' : 'password'}
                                                    name="confirmNewPassword"
                                                    className='form-control'
                                                    placeholder='Confirm Password'
                                                    value={passwordData.confirmNewPassword}
                                                    onChange={handleInputChange}
                                                />
                                                <div className="input-group-append">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                        tabIndex="-1"
                                                    >
                                                        <i className={`fas ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.confirmNewPassword && (
                                                <div style={{ color: 'red' }}>{errors.confirmNewPassword}</div>
                                            )}
                                        </div>

                                        <div className='d-flex mt-5 justify-content-end'>
                                            <button
                                                className='btn cancel-btn'
                                                onClick={handleCancelPassword}
                                                disabled={loading}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className='btn save-btn'
                                                onClick={handleSavePassword}
                                                disabled={loading}
                                            >
                                                {loading ? 'Saving...' : 'Save'}
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <SaveSuccessModel
                show={successShow}
                createMsg={createMsg}
                setShow={setSuccessShow}
                SuccessDoneClick={SuccessDoneClick}
            />
        </>
    );
};

export default Profile;